<template>
  <div class="FilterWrapper">
    <div class="filter-wrapper desktop-filters sm-hide">
      <UIEventsFilterDate
        :initial-date-value="initialDateValue"
        @update-date="(startDate, endDate) => emit('update-date', startDate, endDate)"
      />
      <div
        v-for="filter in availableFilters?.filter((filter) => filter.value !== 'person')"
        :key="filter.value"
        class="filter-item"
      >
        <UIModuleFilterListItems
          :filter="filter"
          :max-items="5"
          @update-filter="(filter, option) => emit('update-filter', filter, option)"
          @delete-filter="(filter) => emit('delete-filter', filter)"
        />
      </div>
    </div>
    <div class="mobile-filters sm-show hide">
      <UIModuleFilterWrapperMobile
        :available-filters="availableFilters"
        :total-results="totalResults"
        :has-date-filter="true"
        :initial-date-value="initialDateValue"
        @update-filter="(filter, option) => emit('update-filter', filter, option)"
        @delete-filter="(filter) => emit('delete-filter', filter)"
        @update-date="(startDate, endDate) => emit('update-date', startDate, endDate)"
        @clear-all-filters="emit('clear-all-filters')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { EventFilter } from '@tc8l/nuxt-overview'

  defineProps<{
    availableFilters: EventFilter[] | undefined
    initialDateValue?: [Date, Date]
    totalResults?: number
  }>()

  const emit = defineEmits<{
    (e: 'update-filter', filterValue: any, optionLabel: any): void
    (e: 'delete-filter', filter: EventFilter): void
    (e: 'clear-all-filters'): void
    (e: 'update-date', startDate: Date | null, endDate: Date | null): void
  }>()
</script>

<style lang="scss" scoped>
  .FilterWrapper {
    width: 100%;
    display: flex;
    flex-direction: column;

    .filter-item {
      margin-bottom: var(--margin-xlg);
    }
  }
</style>
